export default __webpack_public_path__ + "static/media/ygg-sea.8503482b.jpeg";